import { createClient } from '@supabase/supabase-js'
// Vite automatically injects environment variables, no need for dotenv here
const supabaseUrl = "https://khuvqhltxjuqkaxgnnja.supabase.co/"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtodXZxaGx0eGp1cWtheGdubmphIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU5NjM3ODgsImV4cCI6MjA2MTUzOTc4OH0.-xiTZI8qU8nuvKacRZuAVY34uQzk-9RmbrnkW-1XHV0"
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Environment Variables Status:', {
    url: Boolean(supabaseUrl),
    key: Boolean(supabaseAnonKey),
  })
  throw new Error('Missing Supabase credentials. Please check your .env file.')
}
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
